import { createContext, useContext } from "react";

import type {
  AccountingEntity,
  LoginInput,
  Organization,
  SessionPayload,
  SignupInput,
} from "./api-client";

export type AuthStatus = "loading" | "authenticated" | "guest" | "unavailable";

export interface AuthContextValue {
  status: AuthStatus;
  session: SessionPayload | null;
  accountingEntities: AccountingEntity[];
  activeOrganization: Organization | null;
  activeAccountingEntity: AccountingEntity | null;
  initializationError: string | null;
  login: (input: LoginInput) => Promise<void>;
  signup: (input: SignupInput) => Promise<void>;
  logout: () => Promise<void>;
  refreshSession: () => Promise<void>;
  switchOrganization: (organizationId: string) => Promise<void>;
  switchAccountingEntity: (accountingEntityId: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return value;
}
